import React, { useState } from "react";
import styled from "styled-components";
import Joi from "joi";
import Input from "../../common/Input";
import Button from "../../common/Button";
import { device } from "../../common/ScreenSizes";

const AuthLayout = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  justify-items: center;
  background: #3b6ca6 !important;
`;

const AuthLayoutInner = styled.div`
  width: 500px;
  margin: auto;
  background: #ffffff;
  padding: 40px 50px 40px 50px;
  border-radius: 10px;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);

  ${device.max_tablet} {
    width: 500px;
    padding: 30px 40px 30px 40px;
  }

  ${device.max_mobileL} {
    width: 350px;
    padding: 10px 15px 10px 15px;
  }

  ${device.max_mobileM} {
    width: 300px;
    padding: 10px 15px 10px 15px;
  }

  ${device.max_mobileS} {
    width: 250px;
    padding: 10px 15px 10px 15px;
  }
`;
const AuthTitle = styled.h1`
  text-align: center;
  margin: 0;
  line-height: 1;
  padding-bottom: 20px;
  font-size: 2rem;
  word-wrap: break-word;

  ${device.max_mobileL} {
    font-size: 2rem;
  }
  ${device.max_mobileM} {
    font-size: 1.75rem;
  }
  ${device.max_mobileS} {
    font-size: 1.5rem;
  }
`;

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errors, setErrors] = useState({});

  const schema = Joi.object({
    newpassword: Joi.string().min(8).required().label("New Password"),
    repeatpassword: Joi.string().min(8).required().label("Repeat Password"),
  });

  const doSubmit = () => {
    window.location.replace("/");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    setErrors(errors);
    if (errors) return;
    doSubmit();
  };

  const handleChange = ({ currentTarget: input }) => {
    const errorMessage = validateProperty(input);

    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    if (input.name === "newpassword") {
      setNewPassword(input.value);
    } else if (input.name === "repeatpassword") {
      setRepeatPassword(input.value);
    }
  };

  const validate = () => {
    const options = { abortEarly: false };

    const changeData = { newPassword, repeatPassword };
    const { error } = schema.validate(changeData, options);

    if (!error) return null;
    console.log(error);

    const _errors = {};
    for (let index in error.details) {
      let item = error.details[index];
      _errors[item.path[0]] = item.message;
    }
    return _errors;
  };

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema_ = Joi.object({
      [name]: schema.extract(name),
    });
    const { error } = schema_.validate(obj);
    return error ? error.details[0].message : null;
  };
  return (
    <AuthLayout>
      <AuthLayoutInner>
        <AuthTitle>Cambiar la contraseña</AuthTitle>
        <form onSubmit={handleSubmit}>
          <Input
            autoFocus={true}
            name="newpassword"
            label="Nueva contraseña"
            placeholder=""
            type="password"
            value={newPassword}
            onChange={handleChange}
            error={errors["newpassword"]}
          />
          <Input
            autoFocus={false}
            name="repeatpassword"
            label="Confirmar contraseña"
            placeholder=""
            type="password"
            value={repeatPassword}
            onChange={handleChange}
            error={errors["repeatpassword"]}
          />
          <Button label="Cambiar" styleName="btn-main btn-block" />
        </form>
      </AuthLayoutInner>
    </AuthLayout>
  );
};

export default ChangePassword;
